import type { ReactNode } from "react"
import Select from "@/v2-ui/select"
import { useLicenseSeatSourcesQuery } from "@/v2-backoffice-client/license/plan/license.plan.seatSources.query"

export type LicenseSeatSourceSelectProps = {
  value: string
  onValueChange(value: string): void
  /** Extra leading items (e.g. the "not declared" sentinel). */
  children?: ReactNode
}

// The seat-semantics catalog as a select. Each option carries its sentence
// in the open list, where the choice is made: what the customer's seat
// count is under it, and how to recognise it on the invoice (the catalog's
// Description, written for an operator who does not know the licenses). Owns
// its own catalog query so the Update License dialog stays a one-operation
// component. Mount it inside the dialog content.
function LicenseSeatSourceSelect(props: LicenseSeatSourceSelectProps) {
  const { value, onValueChange, children } = props

  const { data, loading } = useLicenseSeatSourcesQuery()
  const seatSources = data?.getLicenseSeatSources ?? []

  return (
    <Select value={value} onValueChange={onValueChange}>
      <Select.Trigger size="md" className="w-full">
        <Select.Value
          placeholder={
            loading
              ? "Loading seat semantics..."
              : "How do subscriptions count seats?"
          }
        />
      </Select.Trigger>
      <Select.Content className="max-w-[440px]">
        {children}
        {seatSources.map((seatSource) => (
          <Select.Item
            key={seatSource.Code}
            value={String(seatSource.Code)}
            description={seatSource.Description}
          >
            {seatSource.Name}
          </Select.Item>
        ))}
      </Select.Content>
    </Select>
  )
}

export default LicenseSeatSourceSelect
